import { createStyles, rem } from '@mantine/core'

export interface StylesParams {
  height: number
}

export default createStyles((theme, _params: StylesParams) => {
  const dark = theme.colorScheme === 'dark'

  const { height } = _params

  return {
    main: {
      backgroundColor: dark ? theme.colors.dark[7] : theme.colors.gray[0],
      borderBottom: `${rem(1)} solid ${dark ? theme.colors.dark[5] : theme.colors.gray[2]}`,
      height: rem(height),
    },

    container: {
      display: 'flex',
      alignItems: 'center',
      height: '100%',
    },
  }
})
